import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import FormDrawer from "src/components/Form/FormDrawer";
import { useAppSelector } from "src/store";
import { updateTutorialPlaylistSaga } from "src/store/tutorials/saga";
import { MODULE_KEYS, TutorialPlaylistDto } from "src/store/tutorials/type";
import * as Yup from "yup";

const TutorialPlaylistEditForm = ({
  data,
  onHide,
  open,
  onSuccessClick,
}: {
  data: TutorialPlaylistDto & { Translates?: any[] };
  onSuccessClick: (message: string) => void;
  onHide: () => void;
  open: boolean;
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const languages = useAppSelector((s) => s.language.languages);

  return (
    <FormDrawer
      drawerProps={{
        isOpen: open,
        onHide: onHide,
        title: t("Tutorials.EditPlaylist").toString(),
      }}
      onHide={onHide}
      loader
      initialValues={{
        Id: data.Id,
        ModuleKey: data.ModuleKey,
        Title: data.Title,
        Subtitle: data.Subtitle,
        Order: data.Order,
        IsActive: data.IsActive,
        // Detay GET'ten gelen çeviriler; her dil için Title/Subtitle. Eksik dil için boş satır.
        Translates: languages.map((l) => {
          const tr = (data.Translates || []).find(
            (x: any) => x.LanguageId === l.EnumId
          );
          return {
            LanguageId: l.EnumId,
            Title: tr ? tr.Title || "" : "",
            Subtitle: tr ? tr.Subtitle || "" : "",
          };
        }),
      }}
      onSubmit={(values) => {
        dispatch(
          updateTutorialPlaylistSaga({
            payload: {
              onSuccess: (message) => {
                onHide();
                onSuccessClick(message);
              },
              onError: (message) => toast.error(message, { theme: "colored" }),
            },
            id: data.Id,
            body: values,
          })
        );
      }}
      validationSchema={Yup.object().shape({
        ModuleKey: Yup.string().required(t("Validation.Required").toString()),
      })}
      multilanguageinputs={[
        { field: "Title", label: t("Tutorials.Title").toString() },
        { field: "Subtitle", label: t("Tutorials.Subtitle").toString() },
      ]}
      inputs={[
        {
          field: "ModuleKey",
          label: t("Tutorials.ModuleKey").toString(),
          type: "select",
          lookup: { labelKey: "Name", valueKey: "EnumId", options: MODULE_KEYS },
        },
        { field: "Order", label: t("Tutorials.Order").toString(), type: "number" },
        { field: "IsActive", label: t("Tutorials.IsActive").toString(), type: "switch" },
      ]}
    />
  );
};
export default TutorialPlaylistEditForm;
